export const promoBannerTheme = {
  hoseasons: {
    backgroundColor: '#F7FAF9',
    fontColor: '#127c69',
  },
  'cottages.com': {
    backgroundColor: '#f8f9fb',
    fontColor: '#506f8b',
  },
  novasol: {
    backgroundColor: '#fafafa',
    fontColor: '#1f314d',
  },
}
